import { defineStore } from "pinia";
import { ref } from "vue";
import Swal from "sweetalert2";
import { changeProfileData, postProfileData } from "@/services/apiServices";


export const useProfileStore = defineStore("profile", () => {
  // Initialize ProfileData directly with the structure you provided
  const ProfileData = ref({
    first_name: "",
    last_name: "",
    contact: "",
    email: "",
    image: "",
  });

  // Fetch profile data
  const fetchProfileData = async () => {
    try {
      const data = await changeProfileData();
      if (data) {
        // Update ProfileData with the actual API data, or fallback to default values
        ProfileData.value = {
          first_name: data.first_name || "",
          last_name: data.last_name || "",
          contact: data.contact || "",
          email: data.email || "",
          image: data.image || "",
        };
      }
    } catch (err) {
      console.error("Error fetching profile data:", err);
    }
  };

  // Post the updated profile data to the server
  const updateProfileData = async (updatedProfile) => {
    try {
      const response = await postProfileData(updatedProfile);
      if (response) {
        // Update the local ProfileData state with the response data if needed
        ProfileData.value = {
          first_name: response.first_name || "",
          last_name: response.last_name || "",
          contact: response.contact || "",
          email: response.email || "",
          image: response.image || "",
        };
        // alert("Profile updated successfully!");
        Swal.fire({
            icon: "success",
            title: "Profile updated successfully",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 1000,
            timerProgressBar: true,
        });
      }
    } catch (err) {
      console.error("Error updating profile data:", err);
    //   alert("Failed to update profile.");
    Swal.fire({
        icon: "failed",
        title: "Failed to update profile", 
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
    });
    }
  };
  return { ProfileData, fetchProfileData, updateProfileData };
});
